<template>

  <div class="card">

    <div class="card-header header-elements-inline" >
      <h5 class="card-title">Item Group Information</h5>
      <div class="header-elements">
        <div class="list-icons">
          <a class="list-icons-item" data-action="remove" @click="closeWindow"></a>
        </div>
      </div>
    </div>

    <div class="card-body">
      <form action="#">

        <div class="form-group row">
          <label class="col-md-2 col-form-label">Name:</label>
          <div class="col-md-10">
            <input  id="txtname" type="text" class="form-control" placeholder="Enter Group Name here..." maxlength="100" v-if="itemgroup" v-model="itemgroup.name" >
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label">Print Name:</label>
          <div class="col-md-10">
            <input type="text" class="form-control" placeholder="Enter your print name here..." maxlength="100" v-if="itemgroup" v-model="itemgroup.p_name">
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label">Nature:</label>
          <div class="col-md-4">
            <select class="form-control" v-if="itemgroup" v-model="itemgroup.nature">
              <option value="1">Physical Product</option>
              <option value="2">Virtual Product</option>
              <option value="3">Services</option>
            </select>
          </div>
          <label class="col-md-2 col-form-label">HSN:</label>
          <div class="col-md-4">
            <input type="text" class="form-control" placeholder="Enter HSN here..." maxlength="8" v-if="itemgroup" v-model="itemgroup.hsn">
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label">GST %:</label>
          <div class="col-md-4">
            <input type="number" class="form-control" placeholder="Enter GST Rate..." max="42" v-if="itemgroup" v-model="itemgroup.taxrate">
          </div>
          <label class="col-md-2 col-form-label">ITC %:</label>
          <div class="col-md-4">
            <input type="number" class="form-control" placeholder="Enter ITC here..." max="100" v-if="itemgroup" v-model="itemgroup.itc" disabled>
          </div>
        </div>

<!--        <div class="form-group row">-->
<!--          <label class="col-md-2 col-form-label">Unit</label>-->
<!--          <div class="col-md-2">-->
<!--            <select class="form-control" v-if="itemgroup" v-model="itemgroup.unit.code">-->
<!--              <option value=1>Nos</option>-->
<!--              <option value=2>Kgs</option>-->
<!--              <option value=3>Mts</option>-->
<!--            </select>-->
<!--          </div>-->
<!--          <label class="col-md-2 col-form-label">Conv Fact:</label>-->
<!--          <div class="col-md-2">-->
<!--            <input type="number" class="form-control" placeholder="Conv Fact" min="1" max="100" v-if="itemgroup" v-model="itemgroup.conv_fact">-->
<!--          </div>-->

<!--          <label class="col-md-2 col-form-label">Sub Unit:</label>-->
<!--          <div class="col-md-2">-->
<!--            <select class="form-control" v-if="itemgroup" v-model="itemgroup.subunit.code">-->
<!--              <option value=1>Nos</option>-->
<!--              <option value=2>Kgs</option>-->
<!--              <option value=3>Mts</option>-->
<!--            </select>-->
<!--          </div>-->

<!--        </div>-->

      </form>
    </div>

    <div class="card-footer">
      <div class="text-right" >
        <button type="button" class="btn btn-primary" @click="saveDocument" >Save<i class="icon-paperplane ml-2"></i></button>
      </div>
    </div>
  </div>
</template>

<script>
import { userService } from '@/store/auth-header.js'
import { store } from '@/store/store.js'
export default {
  name: 'ItemGroupForm',
  store,
  data () {
    return {
      itemgroup: {}
    }
  },
  props: {
    mygroup: {
      type: Object,
      default: () => JSON.parse('{"_id": "",  "code": 0,  "name": "",  "pname": "",  "hsn": "",  "taxrate": 0,  "nature": 1,  "itc": 100 }')
    }
  },
  beforeMount () {
    this.itemgroup = this.mygroup // save props data to itself's data and deal with tms
  },
  component: {

  },
  created () {
    this.$data.itemgroup = JSON.parse('{"_id": "",  "code": 0,  "name": "",  "pname": "",  "hsn": "",  "taxrate": 0,  "nature": 1,  "itc": 100 }')
  },
  mounted () {
    $('#txtname').focus()
  },
  methods: {
    closeWindow () {
      this.$emit('itemgroup_window_closed');
    },
    clear () {
      this.$data.itemgroup = JSON.parse('{"_id": "",  "code": 0,  "name": "",  "pname": "",  "hsn": "",  "taxrate": 0,  "nature": 1,  "itc": 100 }')
    },
    saveDocument () {
      let self = this

      self.$data.itemgroup.nature = parseInt(self.$data.itemgroup.nature)
      self.$data.itemgroup.gstrate = parseFloat(self.$data.itemgroup.gstrate)
      self.$data.itemgroup.itc = parseFloat(self.$data.itemgroup.itc)


      if (self.$data.itemgroup.name.trim().length < 1) {
        alert('Invalid Name')
        return
      }

      const requestOptions = {
        method: (self.$data.itemgroup.code === 0 ? 'POST' : 'PUT'),
        mode: 'cors',
        headers: userService.authHeader(),
        body: JSON.stringify(self.$data.itemgroup)
      }

      fetch(`${process.env.VUE_APP_ROOT_API}api/v1/xpos/itemgroup/`, requestOptions).then(userService.handleResponse).then(function (data) {
        if (data.accepted) {
          swal({ title: 'Success!', text: data.msg, type: 'success' })
          self.group = JSON.parse('{"_id": "",  "code": 0,  "name": "",  "pname": "",  "hsn": "",  "taxrate": 0,  "nature": 1,  "itc": 100 }')
          self.$emit('itemgroup_saved', data.data);
        } else {
          swal({ title: 'Oops!', text: data.msg, type: 'error' })
        }
      }).catch(function (err) {
        swal({ title: 'Oh noes!', text: err.toString(), type: 'error' })
      })
    }
  }
}
</script>

<style scoped>

</style>
